// Controls the upload capacity, preview slots, and accepted image types.
export const MAX_IMAGE_UPLOADS = 2;

export const ACCEPTED_IMAGE_TYPES = 'image/png, image/jpeg, image/gif, image/webp';
